"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationListFlightPassengers = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const ageType_1 = require("../../../../utils/ageType");
const classFunctions_1 = require("../../../../utils/classFunctions");
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
const fullName_1 = require("../../../../utils/fullName");
const Icon_1 = require("../../../Icon");
const Tooltip_1 = require("../../../Tooltip");
require("./index.scss");
const className = 'reservation-list-flight-passengers';
const PassengerItem = (props) => {
    const { passenger, flight } = props;
    const ageType = (0, ageType_1.calculateAgeTypeOnFlight)(passenger.birthday, flight.departure);
    let statusModifier = 'pending';
    for (let i = 0; i < flight.appearing.length; i++) {
        const appearingRecord = flight.appearing[i];
        if (appearingRecord.reservationPassengerId === passenger.id) {
            statusModifier = appearingRecord.isAppeared ? 'appeared' : 'not-appeared';
        }
    }
    const { firstName, lastName } = passenger;
    const fullName = (0, fullName_1.createFullName)(firstName, lastName);
    return (react_1.default.createElement("div", { className: `${className}__passenger` },
        react_1.default.createElement("div", { className: `${className}__left-border` }),
        react_1.default.createElement("div", { className: `${className}__pointer-line` }),
        react_1.default.createElement("div", { className: `${className}__name ${className}__name--${statusModifier}` },
            react_1.default.createElement("span", { className: `${className}__full-name` }, fullName),
            (ageType === 'infant' || ageType === 'child') && (react_1.default.createElement("div", { className: `${className}__icon` },
                react_1.default.createElement(Tooltip_1.Tooltip, { text: (0, ageType_1.translateAgeType)(ageType), modificators: ['white', 'center-aligned'] },
                    react_1.default.createElement(Icon_1.Icon, { name: ageType === 'infant' ? 'nipple' : 'child' })))))));
};
const ReservationListFlightPassengers = (props) => {
    const { flight, passengers, modificators } = props;
    const isCancelled = flight.status === 'cancelled';
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        isCancelled ? 'cancelled' : undefined,
    ]);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__number` }, flight.number),
        react_1.default.createElement("div", { className: `${className}__date-time` }, moment_1.default.parseZone(flight.departure).format(dateTimeFormat_1.DATETIME_FORMAT)),
        react_1.default.createElement("div", { className: `${className}__passengers-tail` }),
        react_1.default.createElement("div", { className: `${className}__passengers` }, passengers.map((passenger, key) => (react_1.default.createElement(PassengerItem, { passenger: passenger, flight: flight, key: key }))))));
};
exports.ReservationListFlightPassengers = ReservationListFlightPassengers;
//# sourceMappingURL=index.js.map